import { PageLoading } from 'components/loading'
import { useAtendimentoProfissionalViewQuery } from 'graphql/hooks.generated'
import { useParams } from 'react-router'

import { convertAtendimentoProfissional } from '../detail/converter-atendimento'
import { AtendimentoVacinacaoBaseView } from './AtendimentoVacinacaoBaseView'

export interface AtendimentoRetificacaoViewParams {
  atendimentoProfissionalId: string
}

export function AtendimentoVacinacaoRetificacaoView() {
  const { atendimentoProfissionalId } = useParams<AtendimentoRetificacaoViewParams>()

  const {
    data: { atendimentoIndividual },
    loading,
  } = useAtendimentoProfissionalViewQuery({
    variables: { atendimentoProfissionalId },
  })

  if (loading) {
    return <PageLoading message='Carregando atendimento...' />
  }

  return (
    <AtendimentoVacinacaoBaseView atendimento={convertAtendimentoProfissional(atendimentoIndividual)} isRetificacao />
  )
}
